"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverMenu = void 0;
var react_1 = __importStar(require("react"));
var PopoverProvider_1 = require("./PopoverProvider");
var Menu_1 = require("./Menu");
var MenuProvider_1 = require("./MenuProvider");
var Popover_1 = require("../Popover/Popover");
var PopoverInner = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, testId = _a.testId, setIsOpen = _a.setIsOpen, rest = __rest(_a, ["children", "testId", "setIsOpen"]);
    var popoverProps = (0, react_1.useContext)(PopoverProvider_1.PopoverContext).popoverProps;
    return popoverProps ? (react_1.default.createElement(Popover_1.Popover, __assign({}, popoverProps, rest, { onClose: function (isOpen) {
            var _a;
            (_a = popoverProps.onClose) === null || _a === void 0 ? void 0 : _a.call(popoverProps, isOpen);
            setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(isOpen);
        }, testId: testId, ref: ref }), children)) : null;
});
PopoverInner.displayName = 'PopoverInner';
exports.PopoverMenu = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.hasArrow, hasArrow = _c === void 0 ? true : _c, testId = _a.testId, width = _a.width, height = _a.height, offset = _a.offset, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, children = _a.children, id = _a.id, rest = __rest(_a, ["placement", "hasArrow", "testId", "width", "height", "offset", "isOpen", "setIsOpen", "children", "id"]);
    var menuElement = Array.isArray(children) && children.find(function (child) { return child.type === Menu_1.Menu; });
    var menuTriggerElement = Array.isArray(children) && children.find(function (child) { return child.type === Menu_1.MenuTrigger; });
    return (react_1.default.createElement(PopoverProvider_1.PopoverProvider, { placement: placement, hasArrow: hasArrow, width: width, height: height, offset: offset, isOpen: isOpen, id: id, setIsOpen: setIsOpen },
        react_1.default.createElement(MenuProvider_1.MenuProvider, null,
            react_1.default.createElement(PopoverInner, __assign({}, rest, { testId: testId, setIsOpen: setIsOpen, ref: ref }), menuElement !== null && menuElement !== void 0 ? menuElement : 'No menu found'), menuTriggerElement !== null && menuTriggerElement !== void 0 ? menuTriggerElement : 'No menu trigger found')));
});
exports.PopoverMenu.displayName = 'PopoverMenu';
